// extracted by mini-css-extract-plugin
export default {"preview-link":"preview-card_preview-link__JAAD7","card-media":"preview-card_card-media__fGpfr"};